import { SoundConstant as SoundConstantBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { SoundConstant } from "@quest/murka-games-behavior-leopard/dist/Game/BehaviorConstants/SoundConstants";

export class SoundConstantGame extends SoundConstantBehavior {

  public static RETRIGGER_POP_UP_SOUND: string = "fs_add";
  public static ANTICIPATION_SOUND: string = "intrigue";
  public static ANTICIPATION_REEL_STOP: string = "intrigue_stop";

    // Voice Over Base Game
    public static VOICE_INTRO: string = "voice_introduce1";
    public static FS_WIN_VOICE: string = "fs_win_voice_1";

    public static MUSIC_SPIN: string = "music_spin";
    public static FREE_GAME_BGM: string = "music_fs";

    //BASEGAME MAGIC POT
    public static PRIZE_VALUE: string = "special_value";
    public static JACKPOT_CONVERT: string = "special_appear_3";
    public static SPECIAL_VALUE_PARTICLE_FLY: string = "special_value_particle_fly";
    public static SPECIAL_VALUE_PARTICLE_LAND: string = "special_value_particle_land";


    // FREEGAME TOP JACKPOT PANEL
    public static JACKPOT_FS_WIN: string = "jackpot_fs_win";
    public static JACKPOT_COUNTER_MINOR: string = "jackpot_counter_minor";
    public static JACKPOT_COUNTER_MINI: string = "jackpot_counter_mini";
    public static JACKPOT_COUNTER_MAJOR: string = "jackpot_counter_major";
    public static JACKPOT_COUNTER_GRAND: string = "jackpot_counter_grand";

    //WIN SOUNDS
    public static INTRO_SUPER_WIN:string="intro_super_win"
    public static INTRO_EPIC_WIN:string="intro_epic_win"
    public static INTRO_CRAZY_WIN:string="intro_crazy_win"
    public static WIN_LINE_SOUND: string = "win_lines_step_1";
    public static BIG_WIN_LOOP: string = "big_win_ode_to_joy";
    public static BIG_WIN_END_SOUND: string = "big_win_end";
    public static CHARACTER_WIN_VOICE: string = "character_win_voice1";

    public static FS_SPECIAL_ICON: string = "fs_special_icon";
    public static ALTERNATIVE_START_FS_VOICE: string = "alternative_start_fs_voice1";
    public static HIGH_WIN_SOUND_2: string = "merged_medium_win";
    public static HIGH_WIN_SOUND_LOOP: string = "medium_win";

    //STACK CONVERSION
    public static CHAR_UNITE: string = "char_unite";
    public static STACK_WIN: string = "character_win";

    //JACKPOT BANNER
    public static JACKPOT_POPUP_MINI:string="jackpot_popup_mini";
    public static JACKPOT_POPUP_MINOR:string="jackpot_popup_minor";
    public static JACKPOT_POPUP_MAJOR:string="jackpot_popup_major";
    public static JACKPOT_POPUP_GRAND:string="jackpot_popup_Grand";
    
    public static FS_CUSTOM_WIN_CODA:string="free_spins_custom_win_coda";
     
}

SoundConstant.FREE_GAME_INTRO = "fs_popup";
SoundConstant.FREE_GAME_OUTRO = "fs_win_popup";
SoundConstant.SCATTER_LANDING = "fs_appear_";
SoundConstant.BIG_WIN_START = "big_win_slot";
